module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/team-5-ec57e4c13afc8df5457684cc0c9000bf.png";